import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './Checkbox.scss';
export function CheckboxFactory(props) {
    let className = '';
    className += props.isDisabled ? ' sg-checkbox-isDisabled' : '';
    className += props.isHovered ? ' sg-checkbox-isHovered' : '';
    return (_jsxs("label", { className: 'sg-checkbox' + className, tabIndex: -1, "data-test-id": props.testId, onClick: props.onClick, children: [_jsx("span", { className: 'sg-checkbox--tick', children: props.children }), props.label && _jsx("span", { className: 'sg-checkbox--label', children: props.label })] }));
}
//# sourceMappingURL=CheckboxFactory.js.map